import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Button, Collapse, Form, Input, InputNumber, Select } from 'tdesign-react';
import Panel from '@/components/Panel';
import Tip from '@/components/Tip';
import { isEmpty, toTsOptions } from '@/utils/common';
import { clusterTypeOptions } from '@/utils/constant';

const { Panel: CollapsePanel } = Collapse;

const { FormItem } = Form;

const initialData = {
  reservedVersionNum: 5,
  type: 0,
  deployDir: '{{cluster_install_path}}/apps/{{gvar_component_name}}',
  repoDir: '{{cluster_install_path}}/repo/{{gvar_component_name}}',
};

export default function BasicStep({ nextStep, cache }) {
  const [form] = Form.useForm();
  const typeChange = (type) => {
    switch (type) {
      case 0:
        form.setFieldsValue({
          deployDir: initialData.deployDir,
          repoDir: initialData.repoDir,
        });
        break;
      case 1:
        form.setFieldsValue({
          deployDir: '{{cluster_install_path}}/{{gvar_cluster_name}}/apps/{{gvar_component_name}}',
          repoDir: '{{cluster_install_path}}/{{gvar_cluster_name}}/repo/{{gvar_component_name}}',
        });
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    if (cache) {
      form.setFieldsValue(cache);
    } else {
      form.reset();
    }
  }, [cache, form]);

  const handleSubmit = ({ validateResult, fields }) => {
    if (validateResult === true) {
      nextStep(fields);
    }
  };

  return (
    <Form
      form={form}
      resetType='initial'
      labelWidth={120}
      initialData={initialData}
      onSubmit={handleSubmit}
    >
      <Root>
        <Top>
          <Title>基本信息</Title>
          <FormContainer style={{ paddingLeft: 38 }}>
            <FormItem name='name' label='组件名称' rules={[{ required: true }]}>
              <Input clearable />
            </FormItem>

            <FormItem name='type' label='组件类型' rules={[{ required: true }]}>
              <Select clearable options={toTsOptions(clusterTypeOptions)} onChange={typeChange} />
            </FormItem>

            <FormItem name='note' label='组件作用备注' rules={[{ required: true }]}>
              <Input clearable />
            </FormItem>
          </FormContainer>
        </Top>
        <Center>
          <Collapse borderless defaultExpandAll expandIconPlacement='right'>
            <CollapsePanel
              header={<Tip content='(选填)以下配置如无特殊需求,保持默认即可'>高级选项</Tip>}
            >
              <FormContainer style={{ paddingTop: 12 }}>
                <FormItem
                  name='deployDir'
                  label={
                    <Tip
                      align='right'
                      content='组件在目标机器上的部署路径，会软链接到真实安装路径。'
                    >
                      部署目录
                    </Tip>
                  }
                >
                  <Input />
                </FormItem>
                <FormItem
                  name='repoDir'
                  label={
                    <Tip align='right' content='组件在目标机器部署的实际路径，会保留多个'>
                      存储目录
                    </Tip>
                  }
                >
                  <Input />
                </FormItem>
                <FormItem
                  name='reservedVersionNum'
                  rules={[
                    {
                      validator: (val) => isEmpty(val) || (val >= 1 && val <= 10),
                      message: '范围1-10',
                    },
                  ]}
                  label={
                    <Tip align='right' content='目标机器最大保留版本数'>
                      保留版本个数
                    </Tip>
                  }
                >
                  <InputNumber theme='normal' decimalPlaces={0} />
                </FormItem>
              </FormContainer>
            </CollapsePanel>
          </Collapse>
        </Center>
        <Bottom>
          <Button theme='primary' type='submit'>
            下一步
          </Button>
        </Bottom>
      </Root>
    </Form>
  );
}

const Root = styled(Panel)`
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  .t-collapse-panel__header {
    height: 54px;
    box-sizing: border-box;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    border-bottom: 1px solid rgba(0, 0, 0, 0.1) !important;
    background: #f7f8fa;
  }
`;

const Top = styled.div`
  margin-bottom: 24px;
  width: 550px;
`;

const Title = styled.div`
  font-size: 14px;
  font-weight: bold;
  padding: 0 0 14px 14px;
`;

const Center = styled.div`
  flex: 1;
`;

const FormContainer = styled.div`
  width: 550px;
`;

const Bottom = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
`;
